import { keyframes } from "@emotion/react";
import { ArrowDropUp, KeyboardArrowUp } from "@mui/icons-material";
import { Box, Fab, Tooltip } from "@mui/material";
import { useState, useEffect } from "react";

const descendAnimation = keyframes`
  from {
    transform: translateY(100%);
    opacity: 0;
  }
  to {
    transform: translateY(0);
    opacity: 1;
  }
`;

const ascendAnimation = keyframes`
  from {
    transform: translateY(0%);
    opacity: 1;
  }
  to {
    transform: translateY(100%);
    opacity: 0;
  }
`;

interface BackToTopButtonProps {
  show: boolean;
}

export default function BackToTopButton({
  show,
}: BackToTopButtonProps): JSX.Element {
  const [showBackToTop, setShowBackToTop] = useState(false);

  useEffect(() => {
    const handleScroll = () => {
      const scrollY = window.scrollY;
      setShowBackToTop(scrollY > 100);
    };

    window.addEventListener("scroll", handleScroll);
    return () => {
      window.removeEventListener("scroll", handleScroll);
    };
  }, []);

  const handleScrollToTop = (): void => {
    window.scrollTo({ top: 0, behavior: "smooth" });
  };

  return (
    <Box
      sx={{
        position: "fixed",
        bottom: "20px",
        right: "20px",
        display: "flex",
        flexDirection: "column",
        alignItems: "flex-end",
        // transition: "bottom 0.3s ease",
      }}
    >
      <Box
        p={2}
        sx={{
          // display: show ? "" : "none",
          animation: `${
            showBackToTop ? descendAnimation : ascendAnimation
          } .2s ease-out forwards`,
        }}
      >
        <Tooltip title="トップに戻る" placement="left">
          <Fab
            onClick={handleScrollToTop}
            style={{ backgroundColor: "rgba(255, 255, 255, 0.8)" }}
          >
            <KeyboardArrowUp />
          </Fab>
        </Tooltip>
      </Box>
    </Box>
  );
}
